// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How the expander derives the telegraph `lift_num` for `units_based` entries.
 */
export enum LobbyVision2LiftNumSource {
  /**
   * `lift_num` = `lift_num_base` + `car_index` (index-based; base is configurable).
   */
  IndexBased = 0,

  /**
   * `lift_num` = the Lift's own per-car ordinal.
   *
   * NOTE: `models.Lift` has NO `car_num` field today — the nearest
   * existing ordinal is `Lift.Position` (int32). This arm maps to
   * `Position` unless a dedicated `Lift.CarNum` column is added.
   */
  LiftPosition = 1,

  /**
   * `lift_num` = the Lift's explicit car number.
   *
   * Uses `FrontEndConfig.Lift.car_num` (uint16, `front_end_config.fbs`),
   * which already exists independent of `Position`/ordering. For
   * controllers whose car labels are assigned/wired independently of
   * bank ordering or physical position (e.g. relabeled/swapped cars).
   */
  LiftCarNum = 2,
}
